import React from 'react';
import { 
  HelpCircle, 
  Shield, 
  Clock, 
  Award, 
  FileText, 
  AlertTriangle, 
  BookOpen, 
  CheckCircle 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по ОСАГО
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Shield,
      title: 'Что такое ОСАГО?',
      description: 'ОСАГО — обязательное страхование автогражданской ответственности. Покрывает ущерб, который вы причинили другим участникам ДТП.'
    },
    {
      icon: Clock,
      title: 'Срок действия полиса',
      description: 'Стандартный срок — 1 год. Можно оформить на срок от 3 месяцев до 1 года для сезонного использования.'
    },
    {
      icon: Award,
      title: 'Скидка за безаварийность',
      description: 'Коэффициент бонус-малус (КБМ) уменьшается каждый год безаварийной езды. Максимальная скидка — 50%.'
    },
    {
      icon: FileText,
      title: 'Электронный полис',
      description: 'Электронный полис ОСАГО имеет такую же юридическую силу, как и бумажный, и стоит столько же.'
    },
    {
      icon: AlertTriangle,
      title: 'Что делать при ДТП?',
      description: 'Остановиться, включить аварийную сигнализацию, выставить знак аварийной остановки и вызвать ГИБДД или оформить европротокол.'
    },
    {
      icon: BookOpen,
      title: 'Ремонт или выплата',
      description: 'По ОСАГО приоритетной формой возмещения является ремонт автомобиля. Денежная компенсация возможна в особых случаях.'
    },
    {
      icon: CheckCircle,
      title: 'Проверка КБМ',
      description: 'Проверить свой КБМ можно на официальном сайте РСА (Российский Союз Автостраховщиков).'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по ОСАГО
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Есть вопросы по ОСАГО?
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Наши специалисты готовы помочь вам подобрать оптимальный вариант страхования.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Получить консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;